var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.5C7.07174 1.5 6.1815 1.86875 5.52513 2.52513C4.86875 3.1815 4.5 4.07174 4.5 5V7C3.96957 7 3.46086 7.21071 3.08579 7.58579C2.71071 7.96086 2.5 8.46957 2.5 9V13.5C2.5 14.0304 2.71071 14.5391 3.08579 14.9142C3.46086 15.2893 3.96957 15.5 4.5 15.5H11.5C12.0304 15.5 12.5391 15.2893 12.9142 14.9142C13.2893 14.5391 13.5 14.0304 13.5 13.5V9C13.5 8.46957 13.2893 7.96086 12.9142 7.58579C12.5391 7.21071 12.0304 7 11.5 7V5C11.5 3.06667 9.93333 1.5 8 1.5ZM10.5 7V5C10.5 4.33696 10.2366 3.70107 9.76777 3.23223C9.29893 2.76339 8.66304 2.5 8 2.5C7.33696 2.5 6.70107 2.76339 6.23223 3.23223C5.76339 3.70107 5.5 4.33696 5.5 5V7H10.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocker);
export default __webpack_public_path__ + "static/media/locker.6918d9fcbf8526aebbbfbd7cb9088e52.svg";
export { ForwardRef as ReactComponent };